<template>
  <div class="ih-container container">
    <figure class="ih-margin-bottom-30 text-center">
      <img src="/img/logo.png" alt />
    </figure>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {},

  created() {},
  mounted() {}
};
</script>

<style lang="scss">
@import "~@/assets/scss/App";
</style>
